/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CustomerAddressesModel } from '../data/models';
import { convertToBoolean } from './convertToBoolean';
import { normalizeAttributes } from './normalizeAttributes';

export const serializeAddressForm = (
  formValues: Record<string, string>
): CustomerAddressesModel => {
  const streetListKeys = ['street', 'streetMultiline_1', 'streetMultiline_2'];
  const elementValues = ['on', 'off', 'true', 'false'];
  const streetList: string[] = [];
  const modifyFormCheckBoxValues: Record<string, boolean> = {};

  for (const key in formValues) {
    const value = formValues[key];

    if (elementValues.includes(value)) {
      modifyFormCheckBoxValues[key] = convertToBoolean(value);
    }

    if (streetListKeys.includes(key)) {
      streetList.push(value);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { street, streetMultiline_2, streetMultiline_1, region, ...props } =
    formValues;
  const [regionCode, regionId] = region
    ? region.split(',')
    : [undefined, undefined];

  const regionConfigs =
    regionId && regionCode
      ? {
          regionId: +regionId,
          regionCode,
        }
      : { region: regionCode };

  const result = normalizeAttributes({
    ...props,
    ...modifyFormCheckBoxValues,
    region: { ...regionConfigs },
    street: streetList,
  });

  return result;
};
